import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.treatink.com/functions/v1",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAffiliateByRef: builder.query({
      query: (ref) => `/affiliates/${ref}`,
    }),
    verifyEditableItem: builder.query({
      query: (itemId) => `/verify-label-edit/${itemId}`,
    }),
    getAffiliateProductsMeta: builder.query({
      query: (affiliateCode) => `/products-meta/${affiliateCode}`,
    }),
    getAffiliateProductsIds: builder.query({
      query: (affiliateCode) => `/partner-products/${affiliateCode}`,
    }),
    getProducts: builder.query({
      query: () => "/products",
    }),
    getProductBundles: builder.query({
      query: () => "/get-product-bundles",
    }),
    trackEvent: builder.mutation({
      query: (eventPayload) => ({
        url: "/track-analytics-events",
        method: "POST",
        body: eventPayload,
      }),
    }),
    addPartnerRequest: builder.mutation({
      query: (formData) => ({
        url: "/partners",
        method: "POST",
        body: formData,
      }),
    }),
    restoreCart: builder.query({
      query: (cartId) => `/get-cart?cart_id=${cartId}`,
    }),
    cancelSubscription: builder.query({
      query: (cancelToken) => `/cancel-subscription/${cancelToken}`,
    }),
  }),
});

export const {
  useGetAffiliateByRefQuery,
  useGetAffiliateProductsMetaQuery,
  useGetAffiliateProductsIdsQuery,
  useVerifyEditableItemQuery,
  useGetProductsQuery,
  useGetProductBundlesQuery,
  useRestoreCartQuery,
  useTrackEventMutation,
  useAddPartnerRequestMutation,
  useCancelSubscriptionQuery
} = apiSlice;